export default __webpack_public_path__ + "static/media/VaccinationBackground.98b15825.svg";